import { provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, withHashLocation } from '@angular/router';

import { AppComponent } from './app/app.component';
import { ROUTES } from './routes';

bootstrapApplication(AppComponent, {
  providers: [provideZoneChangeDetection(), provideRouter(ROUTES, withHashLocation())],
});
